module.exports = __webpack_public_path__ + "static/media/bnb.19b88525.svg";